import React, { useEffect, useMemo, useState } from "react";
import PageHeader from "../../components/PageHeader";
import LoadingSpinner from "../../components/LoadingSpinner";
import { ChevronLeft } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { marked } from "marked";
import DOMPurify from "dompurify";

export default function LegalDoc({ title, url }) {
  const navigate = useNavigate();
  const [text, setText] = useState("");
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    let active = true;
    setLoading(true);
    setError(null);
    fetch(url)
      .then((r) => {
        if (!r.ok) throw new Error(`HTTP ${r.status}`);
        return r.text();
      })
      .then((t) => {
        if (active) setText(t);
      })
      .catch((e) => active && setError(e.message))
      .finally(() => active && setLoading(false));
    return () => {
      active = false;
    };
  }, [url]);

  const html = useMemo(() => {
    try {
      const raw = marked.parse(text || "");
      return DOMPurify.sanitize(raw);
    } catch {
      return null;
    }
  }, [text]);

  return (
    <div className="space-y-4 p-4">
      <PageHeader
        title={title}
        left={
          <button
            type="button"
            className="w-9 h-9 rounded-lg bg-white text-gray-700 border flex items-center justify-center hover:bg-gray-50"
            aria-label="Back"
            onClick={() => navigate(-1)}
          >
            <ChevronLeft className="w-5 h-5" />
          </button>
        }
      />
      {loading ? (
        <LoadingSpinner />
      ) : error ? (
        <div className="text-sm text-red-600">{error}</div>
      ) : html ? (
        <article className="prose max-w-none">
          <div dangerouslySetInnerHTML={{ __html: html }} />
        </article>
      ) : (
        <article className="whitespace-pre-wrap text-sm leading-6">{text}</article>
      )}
    </div>
  );
}
